import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getUserNameByCpf } from './actions';
import api from '../../services/api';

function* getContactsByCpfSaga(
  action: ReturnType<typeof getUserNameByCpf.request>
) {
  try {
    const contacts = yield call(api.getUserNameByCpf, action.payload.cpf);
    yield put(getUserNameByCpf.success(contacts));
  } catch {
    yield put(getUserNameByCpf.failure('Falha ao buscar contatos.'));
  }
}

export default all([
  takeLatest(getUserNameByCpf.request, getContactsByCpfSaga),
]);
